import { FilterValuesWithLocations } from 'common/filters/types';

export enum PerformanceViewByEnum {
  Year = 'year',
  Month = 'month'
}

export interface PerformanceFilterValues extends FilterValuesWithLocations {
  // Undefined
  viewBy: PerformanceViewByEnum | '';
}

export type PerformanceFilterKey = keyof PerformanceFilterValues;

export type PerformanceCategory = 'location' | undefined;
